"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Filter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CheckboxFilter = _interopRequireDefault(require("./CheckboxFilter"));
var _SliderFilter = _interopRequireDefault(require("./SliderFilter"));
var _excluded = ["type"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var DEFAULT_FILTER_MAP = {
  checkbox: _CheckboxFilter.default,
  slider: _SliderFilter.default
};

/**
 * This is a helper component to wrap the Filter component
 *
 * Note: If the filter component type is unknown,
 * a placeholder component will be rendered instead
 *
 * @param {object} props
 * @param {string} props.type - The type of component to render
 * @returns {JSX.Element} - The component to render
 */
var Filter = function Filter(_ref) {
  var type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);

  // Default to the default card map
  if (typeof DEFAULT_FILTER_MAP[type] !== 'undefined') {
    return /*#__PURE__*/(0, _react.createElement)(DEFAULT_FILTER_MAP[type], props);
  }

  // Render a placeholder component
  return /*#__PURE__*/(0, _react.createElement)(function () {
    return /*#__PURE__*/_react.default.createElement("div", null, "The component for ".concat(type, " was not found."));
  });
};
exports.Filter = Filter;
var _default = Filter;
exports.default = _default;